import { Component, OnInit } from "@angular/core";
import { RoleService } from "src/app/shareModule/services/roles/role.service";
import { SharedService } from "src/app/shareModule/services/shared.service";
import { Tab } from "../my-tabs/my-tabs.component";

@Component({
  selector: "marketplace-profile-character",
  templateUrl: "./marketplace-profile-character.component.html",
  styleUrls: ["./marketplace-profile-character.component.scss"],
})
export class MarketplaceProfileCharacterComponent implements OnInit {
  public userLevel: number = 0;
  public tabs: Array<Tab> = [];
  public selMenu: any = 0;

  /**
   * Constructor
   */
  constructor(private sharedService: SharedService, public roleService: RoleService) {}

  ngOnInit(): void {
    this.roleService.rolesSubject.subscribe((roles) => {
      if (roles) {
        this.tabs = [{ title: "Profile" }, { title: "Avatar", condition: this.roleService.roles?.level.includes("MEMBER_PROFILE_AVATAR") }];
      }
    });

    this.sharedService.initProfile$.subscribe((params: any) => {
      this.selMenu = params;
    });
  }

  updateSelMenu(index: number) {
    this.selMenu = index;
  }
}
